import React from "react"

import { Room } from "shared/types/Room"
import { RoomPrice } from "shared/types/__generated__/graphql"

import { FilteredRoomMultiActionHandlers } from "features/room-management/model/useRoomMultiActionHandlers"

import { RoomMultiSelectSidebarView } from "./RoomMultiSelectSidebarView"
import { useRoomMultiSelectSidebarViewModel } from "./hooks/useRoomMultiSelectSidebarViewModel"

export interface RoomMultiSelectSidebarModel {
  projectID: string
  rooms: Room[]

  callbacks: FilteredRoomMultiActionHandlers
  isDisabled?: boolean

  price: RoomPrice | null | undefined
  isLoadingPrice?: boolean

  hideControls?: boolean
}

export interface RoomMultiSelectSidebarProps
  extends RoomMultiSelectSidebarModel {
  hidePrice?: boolean
}

export const RoomMultiSelectSidebar = React.memo(
  (props: RoomMultiSelectSidebarProps) => (
    <RoomMultiSelectSidebarView
      {...useRoomMultiSelectSidebarViewModel(props)}
    />
  )
)
